<template>
  <div style="width: 100vw; height: 100vh;">
    <div class="loginTop">
      <div class="loginTopBg"></div>
      <div class="loginLeft"></div>
      <div class="loginRight">
        <LoginForm></LoginForm>
      </div>
    </div>
    <div class="loginBottom">
      <div class="bottomLine"></div>
      <div class="bottomWord">
        {{$t('Login.footer.copyright')}}<br>
        <span @click="showCopyright">{{$t('Login.copyright')}}</span>
      </div>
    </div>
    <CustomDialog ref="copyrightDialog"
                  v-bind:element="copyrightDialog.element"
                  v-bind:styles="copyrightDialog.styles">
      <template slot="dialog-content">
        <div>
          <div>{{$t('Login.copyright')}}</div>
          <div>{{$t('Login.copyrightInfo.line1')}}</div>
          <div>{{$t('Login.copyrightInfo.line2')}}</div>
          <div>{{$t('Login.copyrightInfo.line3')}}</div>
          <div>{{$t('Login.copyrightInfo.line4')}}</div>
          <div>{{$t('Login.copyrightInfo.line5')}}</div>
          <div>{{$t('Login.copyrightInfo.line6')}}</div>
          <div>{{$t('Login.copyrightInfo.line7')}}</div>
          <div>{{$t('Login.copyrightInfo.line8')}}</div>
          <div>{{$t('Login.copyrightInfo.line9')}}</div>
          <div>{{$t('Login.copyrightInfo.line10')}}</div>
          <div>{{$t('Login.copyrightInfo.line11')}}</div>
          <div>{{$t('Login.copyrightInfo.line12')}}</div>
          <div>{{$t('Login.copyrightInfo.line13')}}</div>
          <div>{{$t('Login.copyrightInfo.line14')}}</div>
          <div>{{$t('Login.copyrightInfo.line15')}}</div>
          <div>{{$t('Login.copyrightInfo.line16')}}</div>
          <div>{{$t('Login.copyrightInfo.line17')}}</div>
          <div>{{$t('Login.copyrightInfo.line18')}}</div>
          <div>{{$t('Login.copyrightInfo.line19')}}</div>
          <div>{{$t('Login.copyrightInfo.line20')}}</div>
          <div>{{$t('Login.copyrightInfo.line21')}}</div>
          <div>{{$t('Login.copyrightInfo.line22')}}</div>
          <div>{{$t('Login.copyrightInfo.line23')}}</div>
          <div>{{$t('Login.copyrightInfo.line24')}}</div>
          <div>{{$t('Login.copyrightInfo.line25')}}</div>
          <div>{{$t('Login.copyrightInfo.line26')}}</div>
        </div>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import CustomDialog from '../components/common/CustomDialog';
import LoginForm from '../components/frame/LoginForm';

export default {
  name: 'LoginLayout',
  components: {
    CustomDialog,
    LoginForm
  },
  data() {
    return {
      copyrightDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'copyrightDialog',
          title: `${this.$t('Login.copyright')}`
        },
        styles: {
          width: '600px',
          height: '400px',
          model: true,
          visible: false
        }
      }
    }
  },
  methods: {
    showCopyright() {
      this.$refs.copyrightDialog.show();
    },
  }
};
</script>
